import axios from "axios";
import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json"
import { authHeader } from "helpers/auth-header";
import { hadleAxiosErrorResponse } from "helpers/handle-response";

export async function ObtenerUsuariosPro(){
    var respuesta: ResponseRequestGeneric<string[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${configData.SERVER_URL}SolicitudPagoHorasExtras/DirectivoUnidad/UsuariosProPowerBI`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: string[] | undefined = responseAxios.data;
        
        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }

    }
    catch(error) {
        respuesta = hadleAxiosErrorResponse<string[]>(error)
    }
    return respuesta
}